<div class="container-fluid">
  <!--
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
   <div class="content-wrapper d-flex justify-content-between">

        <div class="dropdown d-none d-md-block account-container col-md-3" style="padding-right: 15px">
              <button class="btn bg-light shadow-none dropdown-toggle" style="width:auto" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-user-circle fa-3x"></i> {{currentProfile?.firstName}} {{currentProfile?.lastName}}
              </button>

              <ul class="dropdown-menu dropdown-menu-right" style="padding-right:auto; width:auto" aria-labelledby="dropdownMenuButton">
                  <li>
                    <span class="dropdown-item-text dropdown-separator-title">
                      <h4>{{currentProfile?.partnerRole}}</h4>
                      <h5>{{currentProfile?.email}}</h5>
                    </span>
                  </li>
                  <hr>
                  <li>
                    <a class="dropdown-item" routerLink="profile">
                      <div class="icon">
                        <i class="fas fa-user"></i>
                      </div>
                      <div class="text">
                        About
                      </div>
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" routerLink="about">
                      <div class="icon about-icon">
                        <i class="fas fa-info"></i>
                      </div>
                      <div class="text">
                        About
                      </div>
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" routerLink="settings">
                      <div class="icon">
                        <i class="fas fa-cog"></i>
                      </div>
                      <div class="text">
                        Settings
                      </div>
                    </a>
                  </li>

                </ul>
        </div>
      </div>
    </nav>
      -->
  <div class="globe">
    <i class="fa fa-globe fa-2x text-muted"><span class="let small text-muted">EN</span></i>
  </div>
</div>
